import { BackgroundColorProps, BorderRadiusProps, VerticalAlignProps } from 'styled-system'
import { CustomCSSProps, TableBase } from './styles'
import { ReactNode } from 'react'
export interface TableProps {
  children: ReactNode
}

export interface TableHTMLProps {
  id?: string
}

export type TableStyleProps = BackgroundColorProps &
  VerticalAlignProps &
  BorderRadiusProps &
  CustomCSSProps & { color?: string }

type CombinedTableProps = TableProps & TableHTMLProps & TableStyleProps

export const Table = ({ children, ...rest }: CombinedTableProps): JSX.Element => {
  return (
    <TableBase aria-label="table" {...rest}>
      {children}
    </TableBase>
  )
}
